import React from 'react';

function Spinner() {
    return (
        <div className="spinner">
            <p>Loading...</p>
        </div>
    );
}

export default Spinner;
